import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import { useLanguage } from '../../context/LanguageContext';

export default function HeroFourteen() {
  const [isClient, setIsClient] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    setIsClient(true);
  }, []);
  return (
    <section className="digi-hero ptb-120">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5 col-md-6">
            <div className="digi-hero-text mt-5 mt-lg-0">
              {/* <div>
                <span className="span-arrow">Best Digital Agency</span>
                <img src="assets/img/arro-right.svg" alt="arrow" />
              </div> */}
              <h1 className="display-5 fw-bold mb-3">
                {t('hero.hero14.title')}
                <span className="text-orange fw-bold">{" " + t('hero.hero14.highlight')}</span>
              </h1>
              
              <div className="action-btns mt-4 align-items-center d-block d-sm-flex d-lg-flex d-md-flex">
                {/* <ModalVideo
                  channel="youtube"
                  isOpen={isOpen}
                  videoId="hAP2QF--2Dg"
                  onClose={() => setOpen(false)}
                />
                <Link
                  to="/contact-us"
                  className="btn rounded-pill bg-orange me-3"
                >
                  Download Now
                </Link>
                <Link
                  to="#!"
                  onClick={() => setOpen(true)}
                  className="text-decoration-none popup-youtube d-inline-flex align-items-center watch-now-btn mt-3 mt-lg-0 mt-md-0"
                >
                  <i className="fas fa-play"></i> How It Works
                </Link> */}
              </div>
            </div>
          </div>
          <div className="col-lg-7 cool-md-6">
            <div className="digi-hero-img text-center position-relative mt-5">
              <img
                src="assets/img/watch.png"
                className="img-fluid"
                alt="girl"
                style={{maxWidth:"60%"}}
              />
              {/* <ul className="list-unstyled d-none d-xl-block">
                <li>
                  <img
                    src="assets/img/digital-marketing/hero-shape-1.png"
                    alt="shape"
                    className=""
                  />
                </li>
                <li>
                  <img
                    src="assets/img/digital-marketing/hero-shape-2.png"
                    alt="shape"
                  />
                </li>
                <li>
                  <img
                    src="assets/img/digital-marketing/hero-shape-3.png"
                    alt="shape"
                  />
                </li>
                <li>
                  <img
                    src="assets/img/digital-marketing/hero-shape-4.png"
                    alt="shape"
                  />
                </li>
              </ul> */}
            </div>
          </div>
          <div className="row mt-5">
                <div className="col-lg-12">
                  
                  {isClient && (
                    <div className="swiper digi-logo-slider mt-40">
                      <Swiper
                        className="swliper-wrapper align-items-center"
                        modules={[Navigation, Pagination, Autoplay]}
                        spaceBetween={30}
                        loop={true} // Optional: makes the slider loop continuously
                        autoplay={{
                          delay: 2500,
                          disableOnInteraction: false,
                        }} // Optional: enables auto-slide
                        breakpoints={{
                          // when window width is >= 480px
                          480: {
                            slidesPerView: 1,
                            spaceBetween: 10,
                          },
                          // when window width is >= 640px
                          640: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                          },
                          // when window width is >= 768px
                          768: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                          },
                          // when window width is >= 900px
                          900: {
                            slidesPerView: 3.5,
                            spaceBetween: 35,
                          },
                          // when window width is >= 1024px
                          1024: {
                            slidesPerView: 4,
                            spaceBetween: 40,
                          },
                          // when window width is >= 1280px
                          1280: {
                            slidesPerView: 5,
                            spaceBetween: 50,
                          },
                          // when window width is >= 1440px
                          1440: {
                            slidesPerView: 6,
                            spaceBetween: 60,
                          },
                        }}
                      >
                        <SwiperSlide>
                          <div className="single-logo">
                            <img
                              src="assets/img/rightee.png"
                              className="img-fluid"
                              height={30}
                              alt="logo"
                            />
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div className="single-logo">
                            <img
                              src="assets/img/cardiohome.png"
                              className="img-fluid"
                               height={30}
                              alt="logo"
                            />
                          </div>
                        </SwiperSlide>
                          <SwiperSlide>
                          <div className="single-logo">
                            <img
                              src="assets/img/grupovisco.png"
                              className="img-fluid"
                              height={30}
                              alt="logo"
                            />
                          </div>
                        </SwiperSlide>
                            <SwiperSlide>
                          <div className="single-logo">
                            <img
                              src="assets/img/enero.png"
                              className="img-fluid"
                              height={30}
                              alt="logo"
                            />
                          </div>
                        </SwiperSlide>
                             {/* <SwiperSlide>
                          <div className="single-logo">
                            <img
                              src="assets/img/calba.png"
                              className="img-fluid"
                              height={30}
                              alt="logo"
                            />
                          </div>
                        </SwiperSlide>
                             <SwiperSlide>
                          <div className="single-logo">
                            <img
                              src="assets/img/mmarg.png"
                              className="img-fluid"
                              height={30}
                              alt="logo"
                            />
                          </div>
                        </SwiperSlide> */}
                                  <SwiperSlide>
                          <div className="single-logo">
                            <img
                              src="assets/img/tecnoedil.png"
                              className="img-fluid"
                              height={30}
                              alt="logo"
                            />
                          </div>
                        </SwiperSlide>
                                  <SwiperSlide>
                          <div className="single-logo">
                            <img
                              src="assets/img/xhockware.png"
                              className="img-fluid"
                              height={30}
                              alt="logo"
                            />
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div className="single-logo">
                            <img
                              src="assets/img/youbeep-2.png"
                              className="img-fluid"
                              height={30}
                              alt="logo"
                            />
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div className="single-logo">
                            <img
                              src="assets/img/quilmes.png"
                              className="img-fluid"
                              height={30}
                              width={150}
                              alt="logo"
                            />
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div className="single-logo">
                            <img
                              src="assets/img/gob.png"
                              className="img-fluid"
                              
                              height={30}
                              alt="logo"
                            />
                          </div>
                        </SwiperSlide>
                      </Swiper>
                    </div>
                  )}
                </div>
              </div>
        </div>
      </div>
    </section>
  );
}
